import React from 'react'
import ReactOnRails from "react-on-rails/client";

import Cookies from 'frontend/Navigation/Cookies'
import MobileMenu from 'frontend/Navigation/MobileMenu'
import PopularLocations from "frontend/Navigation/PopularLocations";

ReactOnRails.register({ Cookies, MobileMenu, PopularLocations });